import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { activeSparxSelectionResolved } from "@/features/sparxsEditor/store/domainActions";

const activeSparxSlice = createSlice({
  name: "activeSparx",
  initialState: "",
  reducers: {
    setActiveSparx: (_, action: PayloadAction<string>) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(
      activeSparxSelectionResolved,
      (_, action) => action.payload.activeSparxFileName,
    );
  },
});

export const { setActiveSparx } = activeSparxSlice.actions;
export default activeSparxSlice.reducer;
